import React, { useState, useEffect } from "react"
import { observer } from "mobx-react"
import dynamic from "next/dynamic"
import styled from "styled-components"

import { FlowStep } from "mobx/Localization/types"

import { useStores } from "hooks/useStores"
import { Drawer } from "components/common/drawer"
import EditingView from "./editing"
import LocalizationFooter from "./LocalizationFooter"

import { disableBodyScrolling, enableBodyScrolling } from 'utils/utils'

const DrawerBody = styled.div<{fullHeight: boolean}>`
    height: 100%;
    overflow: ${(props) => (props.fullHeight ? 'initial' : 'hidden')};
`

const LocalizationDrawer = () => {

    const [CurrentStepView, setCurrentStepView] = useState<React.ComponentType | null>()
    const [fullHeight, setFullHeight] = useState(false)
    const { localizationStore } = useStores()

    useEffect(() => {
        if(localizationStore.currentStep) {
            setCurrentStepView(dynamic(() => import(`./steps/${  localizationStore.currentStep}`).then((mod) => mod.default)))
        }

        setFullHeight(localizationStore.currentStep === FlowStep.StoreOnMapSelection)

        if(!localizationStore.currentStep) {
            setCurrentStepView(null)
        }
    }, [localizationStore.currentStep])

    useEffect(() => {
        if(localizationStore.started) {
            disableBodyScrolling()
        }
        else {
            enableBodyScrolling()
        }
    }, [localizationStore.started])

	return (
        <Drawer isOpen={localizationStore.started} onOutsideClick={localizationStore.abort} fullHeight={fullHeight}>
            <DrawerBody fullHeight={fullHeight}>
                {!localizationStore.currentStep && localizationStore.editing &&
                    <EditingView />
                }

                {localizationStore.currentStep && CurrentStepView &&
                    <CurrentStepView />
                }
            </DrawerBody>

            {!fullHeight &&
                <LocalizationFooter />
            }
        </Drawer>
	)
}

export default observer(LocalizationDrawer)

